(() => {
  if (window.gwVariantOrderReady) return;
  window.gwVariantOrderReady = true;
  const sort = (root) => root.querySelectorAll('variant-selects select').forEach((select) => {
    if (select.dataset.gwSorted || !/stone.?size|band.?width|length/i.test(select.name)) return;
    select.dataset.gwSorted = 'true';
    const selected = select.value;
    const options = [...select.options];
    options.sort((a,b) => {
      const av=(a.value.match(/\d+(?:\.\d+)?/g)||[]).map(Number);
      const bv=(b.value.match(/\d+(?:\.\d+)?/g)||[]).map(Number);
      for(let i=0;i<Math.max(av.length,bv.length);i++){const difference=(av[i]||0)-(bv[i]||0);if(difference)return difference;}
      return a.value.localeCompare(b.value);
    });
    select.append(...options);select.value = selected;
  });
  sort(document);
  new MutationObserver((mutations) => {
    if (mutations.some((mutation)=>[...mutation.addedNodes].some((node)=>node.nodeType===1 && (node.matches('variant-selects') || node.querySelector('variant-selects'))))) sort(document);
  }).observe(document.body,{childList:true,subtree:true});
})();
